/**
* Form Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Form Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'form-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'form-hero', COMPONENT );
} )( app );
